export default __webpack_public_path__ + "static/media/P104 zu P107.385a8d76.mp3";